import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import './tabs-updated.scss.js';

class TabUpdated extends s {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.withRestrictedContent = false;
        this.panelId = '';
        this._originalId = '';
        this._initialized = false;
    }
    get originalId() {
        return this._originalId;
    }
    get buttonId() {
        return `${this._originalId}-tabbtn`;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this._initialized)
            return;
        this._initialized = true;
        if (!this.id) {
            this.id = `tabitem-${crypto.randomUUID()}`;
        }
        let originalId = this.id;
        if (/^\d/.test(originalId)) {
            originalId = `tab-${originalId}`;
        }
        this._originalId = originalId;
        this.panelId = this._originalId;
        this.setAttribute('role', 'tabpanel');
        this.setAttribute('id', this.panelId);
        this.toggleAttribute('hidden', !this.selected);
        this.toggleAttribute('inert', !this.selected);
        this.setAttribute('aria-labelledby', this.buttonId);
        this.setAttribute('tabindex', this.selected ? '0' : '-1');
    }
    updated(changed) {
        if (changed.has('selected')) {
            this.toggleAttribute('hidden', !this.selected);
            this.toggleAttribute('inert', !this.selected);
            this.setAttribute('tabindex', this.selected ? '0' : '-1');
        }
    }
    handleRestrictedContentSlotChange(e) {
        const slot = e.target;
        const elements = slot.assignedElements({ flatten: true });
        if (elements.length > 0) {
            this.withRestrictedContent = true;
            const restricted = elements[0];
            const container = document.querySelector('.container') || document.body;
            container.append(restricted);
        }
    }
    firstUpdated() {
        var _a;
        (_a = this.querySelector('.seo-title')) === null || _a === void 0 ? void 0 : _a.remove();
        requestAnimationFrame(() => {
            const restrictedElements = this.querySelectorAll('[slot="restricted-content"]');
            if (restrictedElements.length > 0) {
                this.withRestrictedContent = true;
                const restricted = restrictedElements[0];
                const container = document.querySelector('.container') || document.body;
                container.append(restricted);
            }
            if (this.tabId && !this.withRestrictedContent) {
                const restrictedModal = document.querySelector(`restricted-content[tabid="${this.tabId}"]`);
                if (restrictedModal) {
                    this.withRestrictedContent = true;
                }
            }
        });
    }
    render() {
        return $ `<slot></slot><slot name="restricted-content" @slotchange="${this.handleRestrictedContentSlotChange}"></slot>`;
    }
}
__decorate([
    e({ type: String, reflect: true })
], TabUpdated.prototype, "name", void 0);
__decorate([
    e({ type: String, reflect: true })
], TabUpdated.prototype, "tabId", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], TabUpdated.prototype, "selected", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], TabUpdated.prototype, "withRestrictedContent", void 0);
__decorate([
    e()
], TabUpdated.prototype, "redirectUrl", void 0);
__decorate([
    t()
], TabUpdated.prototype, "panelId", void 0);
customElements.define('tab-item-updated', TabUpdated);

export { TabUpdated };
